import React from 'react';
import { MobileLayout } from '../components/MobileLayout';
import { User, Bell, Lock, CreditCard, Globe, HelpCircle, ChevronRight } from 'lucide-react';
interface SettingRow {
  label: string;
  value?: string;
}
interface SettingSection {
  icon: React.ReactNode;
  title: string;
  rows: SettingRow[];
}
export function ImpostazioniPage() {
  const sections: SettingSection[] = [{
    icon: <User size={18} data-id="element-2556" />,
    title: 'Account',
    rows: [{
      label: 'Profilo'
    }, {
      label: 'Email e Password'
    }]
  }, {
    icon: <Bell size={18} data-id="element-2557" />,
    title: 'Notifiche',
    rows: [{
      label: 'Preferenze Notifiche'
    }]
  }, {
    icon: <Lock size={18} data-id="element-2558" />,
    title: 'Sicurezza',
    rows: [{
      label: 'Autenticazione a due fattori'
    }]
  }, {
    icon: <CreditCard size={18} data-id="element-2559" />,
    title: 'Fatturazione',
    rows: [{
      label: 'Metodi di Pagamento'
    }, {
      label: 'Storico Fatture'
    }]
  }, {
    icon: <Globe size={18} data-id="element-2560" />,
    title: 'Lingua e Regione',
    rows: [{
      label: 'Lingua',
      value: 'Italiano'
    }]
  }, {
    icon: <HelpCircle size={18} data-id="element-2561" />,
    title: 'Supporto',
    rows: [{
      label: 'Centro Assistenza'
    }, {
      label: 'Contattaci'
    }]
  }];
  return <MobileLayout data-id="element-2562">
      {/* Page Header */}
      <div className="mb-6 lg:mb-8" data-id="element-2563">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2564">
          Impostazioni
        </h1>
      </div>

      {/* Settings Sections */}
      <div className="space-y-4" data-id="element-2565">
        {sections.map(section => <div key={section.title} className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-2566">
            <h2 className="text-sm font-semibold text-navy mb-2 flex items-center gap-2" data-id="element-2567">
              {section.icon}
              {section.title}
            </h2>
            {/* Rows: full-width, separated by dividers */}
            <div className="-mx-4 lg:-mx-6 divide-y divide-gray-100 border-t border-gray-100" data-id="element-2568">
              {section.rows.map(row => <button key={row.label} className="w-full flex items-center justify-between px-4 lg:px-6 py-3.5 hover:bg-gray-50 transition-colors text-left min-h-[44px]" data-id="element-2569">
                  <span className="text-sm text-navy" data-id="element-2570">{row.label}</span>
                  {row.value ? <span className="text-xs text-gray-500" data-id="element-2571">{row.value}</span> : <ChevronRight size={16} className="text-gray-400" data-id="element-2572" />}
                </button>)}
            </div>
          </div>)}

        {/* Logout Button */}
        <button className="w-full px-4 py-3 border border-red-200 text-red-600 rounded-lg hover:bg-red-50 transition-colors text-sm font-medium min-h-[44px]" data-id="element-2573">
          Esci dall'Account
        </button>
      </div>
    </MobileLayout>;
}